import { Route, Routes } from 'react-router-dom'
import { Suspense } from 'react'
import Loading from '../components/Loading'
import ROUTER from '../utils/router'

const renderRoute = (route, parentKey = 'root') => {
    const keyBase = `${parentKey}-${route.path || 'index'}`

    if (!route.component) {
        return 
    }
    

    if (route.index) {
        return <Route key={keyBase} index element={route.component} />
    }

    return (
        <Route key={keyBase} path={route.path} element={route.component}>
            {route.children?.map((child, idx) => renderRoute(child, `${keyBase}-${idx}`))}
        </Route>
    )
}

const AppRouter = () => {
    return (
        <Suspense fallback={<Loading />}>
            <Routes>
                {ROUTER.map((route, idx) => renderRoute(route, `top-${idx}`))}
            </Routes>
        </Suspense>
    );
};

export default AppRouter;